/* Shared Pixify palette adapter; independently usable by either product section. */
if (!customElements.get('product-palette')) {
  customElements.define('product-palette', class extends HTMLElement {
    connectedCallback() {
      if (this.paletteObserver) return;
      const panel = this.closest('.applications-section, .product-tiling__dialog');
      const page = this.closest('#main');
      if (!panel || !page) return;
      // Pixify renders the product's metadata colours in this existing block.
      // Read those values only: no image analysis, downloads or metadata writes.
      const selector = '.pi-color-palette';
      const updatePalette = () => {
        const palette = page.querySelector(selector);
        const colors = [...new Set(Array.from(palette?.children || [], swatch =>
          swatch.textContent.trim().match(/^#[\da-f]{6}$/i)?.[0].toUpperCase()
        ).filter(Boolean))].slice(0, 8);
        if (!colors.length) {
          panel.style.removeProperty('--swatch-palette-gradient');
          return;
        }
        // Mix with white so even black or saturated palettes stay behind the artwork.
        const softened = colors.map(hex => {
          const rgb = [1, 3, 5].map(i => Math.round(parseInt(hex.slice(i, i + 2), 16) * .22 + 255 * .78));
          return `rgb(${rgb.join(', ')})`;
        });
        if (softened.length === 1) softened.push('#f4f4f4');
        const stops = softened.map((color, i) => `${color} ${Math.round(i * 100 / (softened.length - 1))}%`);
        panel.style.setProperty('--swatch-palette-gradient', `linear-gradient(${panel.matches('.applications-section') ? 225 : 135}deg, ${stops.join(', ')})`);
      };
      updatePalette();
      // Also handle delayed app rendering and Shopify section replacement.
      this.paletteObserver = new MutationObserver(records => {
        const touchesPalette = node => node.nodeType === 1 &&
          (node.matches(selector) || node.querySelector(selector));
        if (records.some(record => {
          const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return element?.closest(selector) ||
            [...record.addedNodes, ...record.removedNodes].some(touchesPalette);
        })) updatePalette();
      });
      this.paletteObserver.observe(page, { childList: true, subtree: true, characterData: true });
    }
    disconnectedCallback() {
      this.paletteObserver?.disconnect();
      this.paletteObserver = null;
    }
  });
}
